export default "__VITE_ASSET__CEWBr_$U__"